import * as Yup from 'yup';
import patterns from '../../constants/patterns';
import {
  CONTROL_TERMS,
  CONTROL_TEXT
} from '../../pages/Account/components/RxFormCustomization/FormBuilder/helpers';

export const patientNameSchema = Yup.string()
  .required('Required')
  .matches(
    patterns.name,
    'Name may only contain letters (first letter uppercase), spaces, points, brackets, and apostrophes.'
  )
  .max(255)
  .matches(
    patterns.acceptableLanguages,
    "Doesn't support right-to-left writing and ideogram languages."
  );

export const caseNumberSchema = Yup.string()
  .nullable()
  .matches(
    patterns.case_number,
    'Case number may only contain letters, spaces, points, brackets, and apostrophes.'
  );

export const createValidationSchema = (
  baseSchema,
  attributes = [],
  overrideOptions = {},
  newControls = []
) => {
  const options = { requireDoctor: false, ...overrideOptions };
  const additionalValidation = { ...baseSchema };

  if (options.requireDoctor) {
    additionalValidation.user_id = Yup.number().required('Required');
  }

  const customFieldsWithValidation = [];

  if (newControls && newControls.length) {
    newControls.forEach(field => {
      let validation = null;

      if (field.rules && field.rules.required) {
        if (field.system_type === CONTROL_TEXT && field.props.type === 'number') {
          validation = Yup.number().required('Required');
        } else if (field.system_type === CONTROL_TERMS) {
          validation = Yup.number()
            .required('Required')
            .test('is-terms', 'Required', value => parseInt(value, 10) === 1);
        } else {
          validation = Yup.string().required('Required');
        }
      }

      if (validation) {
        additionalValidation[field.system_name] = validation;
        customFieldsWithValidation.push(field.system_name);
      }
    });
  }

  const targetAttributes = [...attributes, ...customFieldsWithValidation];

  if (targetAttributes.length) {
    const only = {};
    targetAttributes.forEach(attribute => {
      if (additionalValidation[attribute]) {
        only[attribute] = additionalValidation[attribute];
      }
    });
    return Yup.object().shape(only);
  }

  return Yup.object().shape(additionalValidation);
};
